export default __webpack_public_path__ + "static/media/Error_Black.16a983cf.svg";